/**
 * Timing Constants
 * 
 * Centralized timing values for delays, timeouts, and intervals
 */

// Timeout Values (in milliseconds)
export const TIMEOUTS = {
  // Initialization
  INIT_DELAY: 50,           // Component initialization delay
  
  // UI Feedback
  FEEDBACK_MESSAGE: 3000,   // Feedback message display duration
  ACHIEVEMENT_DISPLAY: 3000, // Achievement badge display duration
  HINT_DISPLAY: 5000,       // Hint display duration
  MODAL_CLOSE: 2000,        // Modal close delay
  
  // Scroll and Animation
  SCROLL_DELAY: 200,        // Scroll animation delay
  SCROLL_BRIEF_DELAY: 200,  // Brief scroll delay for question rendering
  SCROLL_OPTIMIZE: 100,     // Scroll optimization delay
  
  // Email/Share
  EMAIL_SENT_DELAY: 2000,   // Delay after email sent before closing modal
  
  // Music/Audio
  MUSIC_CHECK: 1000,        // Music playback check interval
  
  // Parent Mode
  INACTIVITY_RESET: 30 * 60 * 1000, // 30 minutes in milliseconds
  
  // Question Flow
  QUESTION_ADVANCE_DELAY: 1200,     // Delay before advancing to next question
};

// Response Time Thresholds
export const RESPONSE_TIMES = {
  FAST: 3000,      // 3 seconds - fast response
  SLOW: 10000,     // 10 seconds - slow response
  IDEAL: 5000,     // 5 seconds - ideal response time
};

// Time Conversions
export const TIME_CONVERSIONS = {
  MS_PER_SECOND: 1000,
  MS_PER_MINUTE: 60 * 1000,
  MS_PER_HOUR: 60 * 60 * 1000,
  MS_PER_DAY: 24 * 60 * 60 * 1000,
  MS_PER_WEEK: 7 * 24 * 60 * 60 * 1000,
};

// Date/Time Constants
export const ONE_DAY_MS = TIME_CONVERSIONS.MS_PER_DAY;
export const ONE_WEEK_MS = TIME_CONVERSIONS.MS_PER_WEEK;

